export const EMAIL_VERIFICATION_QUERY_PARAMETER = 'code';
